import { connect } from 'react-redux';
import { clearGenerators } from 'js/store/actions/graphGeneratorData';
import SelectedGeneratorsDesktop from 'js/components/legacy/SelectedGeneratorsDesktop';
export default connect(null, function (dispatch, ownProps) {
  return {
    plotClearGenerators: function plotClearGenerators() {
      return dispatch(clearGenerators(ownProps.plotId));
    }
  };
})(SelectedGeneratorsDesktop);